import React from 'react';
import {useParams} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {
  useGetNextStepAfterIV as useSharedGetNextStepAfterIV,
  type IVFlowPaths,
} from '@chekin/shared/guest-form';
import {IV_DOCUMENT_IMAGE_TYPES} from '@chekin/core';

type Props = {
  docType?: IV_DOCUMENT_IMAGE_TYPES;
  onlyScanning?: boolean;
};
function useGetNextStepAfterIV({docType, onlyScanning}: Props) {
  const {id} = useParams();

  const paths = React.useMemo<IVFlowPaths>(
    () => ({
      selfie: `../${PATHS.verification.selfie}`,
      back: `../${PATHS.verification.back}`,
      done: id
        ? `../../${PATHS.addPersonalDataForm}/${id}`
        : `../../${PATHS.addPersonalDataForm}`,
    }),
    [id],
  );

  return useSharedGetNextStepAfterIV({docType, onlyScanning, paths});
}

export {useGetNextStepAfterIV};
